import { User } from 'src/models/user.interface';
import axiosCore from 'src/utils/axiosCore';

import { APIResponse } from './APIResponse';
import { prepareAxiosError } from './handleApiAxiosError';

export const updateSelectedSpace = async ({ spaceId }: { spaceId: string }) => {
  try {
    const {
      data: { data, message }
    } = await axiosCore.put<APIResponse<User>>(`/user/space/${spaceId}`);

    return { data, message };
  } catch (error) {
    throw prepareAxiosError(error);
  }
};
